import  networks  from '../store/networks.js'

export default {

      decodeBase64 (s) {
        let Base64 = {
          _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
          _decode (s)
{
    var e = {}, i, k, v = [], r = '', w = String.fromCharCode;
    var n = [[65, 91], [97, 123], [48, 58], [43, 44], [47, 48]];

    for (var z in n)
    {
        for (i = n[z][0]; i < n[z][1]; i++)
        {
            v.push(w(i));
        }
    }
    for (i = 0; i < 64; i++)
    {
        e[v[i]] = i;
    }

    for (i = 0; i < s.length; i+=72)
    {
        var b = 0, c, x, l = 0, o = s.substring(i, i+72);
        for (x = 0; x < o.length; x++)
        {
            c = e[o.charAt(x)];
            b = (b << 6) + c;
            l += 6;
            while (l >= 8)
            {
                r += w((b >>> (l -= 8)) % 256);
            }
         }
    }
    r = Base64.utf8Decode(r);
    return r;
},
          _09decode: (s) => {
            var e={},i,b=0,c,x,l=0,a,r='',w=String.fromCharCode,L=s.length;
            var A="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
            for(i=0;i<64;i++){e[A.charAt(i)]=i;}
            for(x=0;x<L;x++){
                c=e[s.charAt(x)];b=(b<<6)+c;l+=6;
                while(l>=8){((a=(b>>>(l-=8))&0xff)||(x<(L-2)))&&(r+=w(a));}
            }

            r = Base64.utf8Decode(r);

            return r;
        },
          decode: (e) => {
              var t = "";
              var n, r, i;
              var s, o, u, a;
              var f = 0;
              e = e.replace(/\++[++^A-Za-z0-9+/=]/g, "");
              while (f < e.length) {
                  s = Base64._keyStr.indexOf(e.charAt(f++));
                  o = Base64._keyStr.indexOf(e.charAt(f++));
                  u = Base64._keyStr.indexOf(e.charAt(f++));
                  a = Base64._keyStr.indexOf(e.charAt(f++));
                  n = s << 2 | o >> 4;
                  r = (o & 15) << 4 | u >> 2;
                  i = (u & 3) << 6 | a;
                  t = t + String.fromCharCode(n);
                  if (u != 64) {
                      t = t + String.fromCharCode(r)
                  }
                  if (a != 64) {
                      t = t + String.fromCharCode(i)
                  }
              }
              t = Base64.utf8Decode(t);
              return t
          },
          utf8Decode(utf8String) {
            if (typeof utf8String != 'string') throw new TypeError('parameter ‘utf8String’ is not a string');
            // note: decode 3-byte chars first as decoded 2-byte strings could appear to be 3-byte char!
            const unicodeString = utf8String.replace(
                /[\u00e0-\u00ef][\u0080-\u00bf][\u0080-\u00bf]/g,  // 3-byte chars
                function(c) {  // (note parentheses for precedence)
                    var cc = ((c.charCodeAt(0)&0x0f)<<12) | ((c.charCodeAt(1)&0x3f)<<6) | ( c.charCodeAt(2)&0x3f);
                    return String.fromCharCode(cc); }
            ).replace(
                /[\u00c0-\u00df][\u0080-\u00bf]/g,                 // 2-byte chars
                function(c) {  // (note parentheses for precedence)
                    var cc = (c.charCodeAt(0)&0x1f)<<6 | c.charCodeAt(1)&0x3f;
                    return String.fromCharCode(cc); }
            );
            return unicodeString;
          },
          _utf8_decode: (e) => {
              var t = "";
              var n = 0;
              var r = 0;
              var c1 = 0;
              var c2 = 0;
              var c3 = 0;
              while (n < e.length) {
                  r = e.charCodeAt(n);
                  if (r < 128) {
                      t += String.fromCharCode(r);
                      n++
                  } else if (r > 191 && r < 224) {
                      c2 = e.charCodeAt(n + 1);
                      t += String.fromCharCode((r & 31) << 6 | c2 & 63);
                      n += 2
                  } else {
                      c2 = e.charCodeAt(n + 1);
                      c3 = e.charCodeAt(n + 2);
                      t += String.fromCharCode((r & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
                      n += 3
                  }
              }
              return t
          }
      };

        return Base64.decode(s);
    },
    since (ts) {      
        ts = ts / 1000;
        var now = new Date();
        ts = new Date(ts * 1000);
        var delta = now.getTime() - ts.getTime();
  
        delta = delta / 1000; //us to s
  
        var ps, pm, ph, pd, min, hou, sec, days;
        delta = delta + 1;
        
        if (delta <= 59) {
          ps = delta > 1 ? "s" : "";
          return Math.floor(delta)  + " second" + ps;
        }
  
        if (delta >= 60 && delta <= 3599) {
          min = Math.floor(delta / 60);
          sec = delta - min * 60;
          pm = min > 1 ? "s" : "";
          ps = sec > 1 ? "s" : "";
          return min + "m " + Math.floor(sec) + "s";
        }
  
        if (delta >= 3600 && delta <= 86399) {
          hou = Math.floor(delta / 3600);
          min = Math.floor((delta - hou * 3600) / 60);
          ph = hou > 1 ? "s" : "";
          pm = min > 1 ? "s" : "";
          return hou + "h";
        }
  
        if (delta >= 86400) {
          days = Math.floor(delta / 86400);
          hou = Math.floor((delta - days * 86400) / 60 / 60);
          pd = days > 1 ? "s" : "";
          ph = hou > 1 ? "s" : "";
  
          if (hou == 0) return days + "d";
          else return days + "d " + hou + "h";
        }
    },
    duration (ts) {      
      ts = ts / 1000;
      var now = new Date();
      ts = new Date(ts * 1000);
      var delta = ts.getTime();
      delta = ts / 1000; //us to s
  
        var ps, pm, ph, pd, min, hou, sec, days;
  
        if (delta <= 59) {
          ps = delta > 1 ? "s" : "";
          return Math.floor(delta) + " second" + ps;
        }
  
        if (delta >= 60 && delta <= 3599) {
          min = Math.floor(delta / 60);
          sec = delta - min * 60;
          pm = min > 1 ? "s" : "";
          ps = sec > 1 ? "s" : "";
          return min + "m " + Math.floor(sec) + "s";
        }
  
        if (delta >= 3600 && delta <= 86399) {
          hou = Math.floor(delta / 3600);
          min = Math.floor((delta - hou * 3600) / 60);
          ph = hou > 1 ? "s" : "";
          pm = min > 1 ? "s" : "";
          return hou + "h";
        }
  
        if (delta >= 86400) {
          days = Math.floor(delta / 86400);
          hou = Math.floor((delta - days * 86400) / 60 / 60);
          pd = days > 1 ? "s" : "";
          ph = hou > 1 ? "s" : "";
  
          if (hou == 0) return days + "d";
          else return days + "d " + hou + "h";
        }
    },
    replaceImg(str) {
      if(str){
        return str.replace("_normal", "");
      }else{
        return '/img/avatar.jpg'
      }
      },
    extractName(str){
      var nameReplace = str.replace(/@.*$/,"");
      var name = nameReplace!==str ? nameReplace : null;
      return name;
    },
    arrayToObject(array, keyField){
     return array.reduce((obj, item) => {
      obj[item[keyField]] = item
      return obj
    }, {})},
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
  },
    getFirstLetter(string) {
      return string.charAt(0).toLowerCase()
  },
  enumarate(tags){
    return _.chain(tags).keyBy('identifier').mapValues(v => v).value()
  },
  md5(inputString) {
    var hc="0123456789abcdef";
    function rh(n) {var j,s="";for(j=0;j<=3;j++) s+=hc.charAt((n>>(j*8+4))&0x0F)+hc.charAt((n>>(j*8))&0x0F);return s;}
    function ad(x,y) {var l=(x&0xFFFF)+(y&0xFFFF);var m=(x>>16)+(y>>16)+(l>>16);return (m<<16)|(l&0xFFFF);}
    function rl(n,c)            {return (n<<c)|(n>>>(32-c));}
    function cm(q,a,b,x,s,t)    {return ad(rl(ad(ad(a,q),ad(x,t)),s),b);}
    function ff(a,b,c,d,x,s,t)  {return cm((b&c)|((~b)&d),a,b,x,s,t);}
    function gg(a,b,c,d,x,s,t)  {return cm((b&d)|(c&(~d)),a,b,x,s,t);}
    function hh(a,b,c,d,x,s,t)  {return cm(b^c^d,a,b,x,s,t);}
    function ii(a,b,c,d,x,s,t)  {return cm(c^(b|(~d)),a,b,x,s,t);}
    function sb(x) {
        var i;var nblk=((x.length+8)>>6)+1;var blks=new Array(nblk*16);for(i=0;i<nblk*16;i++) blks[i]=0;
        for(i=0;i<x.length;i++) blks[i>>2]|=x.charCodeAt(i)<<((i%4)*8);
        blks[i>>2]|=0x80<<((i%4)*8);blks[nblk*16-2]=x.length*8;return blks;
    }
    var i,x=sb(inputString),a=1732584193,b=-271733879,c=-1732584194,d=271733878,olda,oldb,oldc,oldd;
    for(i=0;i<x.length;i+=16) {olda=a;oldb=b;oldc=c;oldd=d;
        a=ff(a,b,c,d,x[i+ 0], 7, -680876936);d=ff(d,a,b,c,x[i+ 1],12, -389564586);c=ff(c,d,a,b,x[i+ 2],17,  606105819);
        b=ff(b,c,d,a,x[i+ 3],22,-1044525330);a=ff(a,b,c,d,x[i+ 4], 7, -176418897);d=ff(d,a,b,c,x[i+ 5],12, 1200080426);
        c=ff(c,d,a,b,x[i+ 6],17,-1473231341);b=ff(b,c,d,a,x[i+ 7],22,  -45705983);a=ff(a,b,c,d,x[i+ 8], 7, 1770035416);
        d=ff(d,a,b,c,x[i+ 9],12,-1958414417);c=ff(c,d,a,b,x[i+10],17,     -42063);b=ff(b,c,d,a,x[i+11],22,-1990404162);
        a=ff(a,b,c,d,x[i+12], 7, 1804603682);d=ff(d,a,b,c,x[i+13],12,  -40341101);c=ff(c,d,a,b,x[i+14],17,-1502002290);
        b=ff(b,c,d,a,x[i+15],22, 1236535329);a=gg(a,b,c,d,x[i+ 1], 5, -165796510);d=gg(d,a,b,c,x[i+ 6], 9,-1069501632);
        c=gg(c,d,a,b,x[i+11],14,  643717713);b=gg(b,c,d,a,x[i+ 0],20, -373897302);a=gg(a,b,c,d,x[i+ 5], 5, -701558691);
        d=gg(d,a,b,c,x[i+10], 9,   38016083);c=gg(c,d,a,b,x[i+15],14, -660478335);b=gg(b,c,d,a,x[i+ 4],20, -405537848);
        a=gg(a,b,c,d,x[i+ 9], 5,  568446438);d=gg(d,a,b,c,x[i+14], 9,-1019803690);c=gg(c,d,a,b,x[i+ 3],14, -187363961);
        b=gg(b,c,d,a,x[i+ 8],20, 1163531501);a=gg(a,b,c,d,x[i+13], 5,-1444681467);d=gg(d,a,b,c,x[i+ 2], 9,  -51403784);
        c=gg(c,d,a,b,x[i+ 7],14, 1735328473);b=gg(b,c,d,a,x[i+12],20,-1926607734);a=hh(a,b,c,d,x[i+ 5], 4,    -378558);
        d=hh(d,a,b,c,x[i+ 8],11,-2022574463);c=hh(c,d,a,b,x[i+11],16, 1839030562);b=hh(b,c,d,a,x[i+14],23,  -35309556);
        a=hh(a,b,c,d,x[i+ 1], 4,-1530992060);d=hh(d,a,b,c,x[i+ 4],11, 1272893353);c=hh(c,d,a,b,x[i+ 7],16, -155497632);
        b=hh(b,c,d,a,x[i+10],23,-1094730640);a=hh(a,b,c,d,x[i+13], 4,  681279174);d=hh(d,a,b,c,x[i+ 0],11, -358537222);
        c=hh(c,d,a,b,x[i+ 3],16, -722521979);b=hh(b,c,d,a,x[i+ 6],23,   76029189);a=hh(a,b,c,d,x[i+ 9], 4, -640364487);
        d=hh(d,a,b,c,x[i+12],11, -421815835);c=hh(c,d,a,b,x[i+15],16,  530742520);b=hh(b,c,d,a,x[i+ 2],23, -995338651);
        a=ii(a,b,c,d,x[i+ 0], 6, -198630844);d=ii(d,a,b,c,x[i+ 7],10, 1126891415);c=ii(c,d,a,b,x[i+14],15,-1416354905);
        b=ii(b,c,d,a,x[i+ 5],21,  -57434055);a=ii(a,b,c,d,x[i+12], 6, 1700485571);d=ii(d,a,b,c,x[i+ 3],10,-1894986606);
        c=ii(c,d,a,b,x[i+10],15,   -1051523);b=ii(b,c,d,a,x[i+ 1],21,-2054922799);a=ii(a,b,c,d,x[i+ 8], 6, 1873313359);
        d=ii(d,a,b,c,x[i+15],10,  -30611744);c=ii(c,d,a,b,x[i+ 6],15,-1560198380);b=ii(b,c,d,a,x[i+13],21, 1309151649);
        a=ii(a,b,c,d,x[i+ 4], 6, -145523070);d=ii(d,a,b,c,x[i+11],10,-1120210379);c=ii(c,d,a,b,x[i+ 2],15,  718787259);
        b=ii(b,c,d,a,x[i+ 9],21, -343485551);a=ad(a,olda);b=ad(b,oldb);c=ad(c,oldc);d=ad(d,oldd);
    }
    return rh(a)+rh(b)+rh(c)+rh(d);
},
    turkishToEnglish(_string){
      return _string.replace('Ğ','g')
        .replace('Ü','u')
        .replace('Ş','s')
        .replace('I','i')
        .replace('İ','i')
        .replace('Ö','o')
        .replace('Ç','c')
        .replace('ğ','g')
 		    .replace('ü','u')
        .replace('ş','s')
        .replace('ı','i')
        .replace('ö','o')
        .replace('ç','c');
    },
    getPlatformImage(platformId){
      let fileName = '';
      let mainPath = '/img/socialSvg/';

      // Facebook
      if(networks.state.networksById[platformId].name == 'Facebook') fileName = 'facebook';

      // Instagram
      if(networks.state.networksById[platformId].name == 'Instagram') fileName = 'instagram';

      // Twitter
      if(networks.state.networksById[platformId].name == 'Twitter') fileName = 'twitter';

      // Youtube
      if(networks.state.networksById[platformId].name == 'Youtube') fileName = 'youtube';

      // Email
      if(networks.state.networksById[platformId].name == 'Email') fileName = 'email';

      // Phone
      if(networks.state.networksById[platformId].name == 'Phone') fileName = 'phone';

      // Google Play
      if(networks.state.networksById[platformId].name == 'Google Play') fileName = 'playStore';

      // Google Play
      if(networks.state.networksById[platformId].name == 'App Store') fileName = 'appStore';

      // Gmail
      if(networks.state.networksById[platformId].name == 'Gmail') fileName = 'gmail';

      // Documents
      if(networks.state.networksById[platformId].name == 'Document') fileName = 'documents2';

      return mainPath + fileName +'.svg';
    }
}


// WEBPACK FOOTER //
// ./src/libs/functions.js